import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import Button from "../../../../modules/commons/Button";
import SimpleTimePicker from "../../../../modules/SimpleTimePicker";
import moment from "moment";
import Api from "../../../../Services/Api";
import { v4 as uuidv4 } from "uuid";
import { shortUuid } from "../../masterSopir/utils";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { ACTIVITY_TYPE } from "../../../common/Constants";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import {
  fetchDataAsync,
  FormatCurrencyWithoutSymbol,
} from "../../../../Services/Utils";
import * as R from "ramda";
import MultipleJobModal from "./multipleJobModal";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";

class TabJob extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || [],
      dataJasa: [],
      editingIndex: null,
      promoAllJob: false,
      satuan: null,
      nilaiDiskon: null,
      dataSatuan: [
        { value: "AMOUNT", label: "Currency" },
        { value: "PERCENTAGE", label: "Percentage" },
      ],
      pagination: {
        totalData: props.data?.length || 0,
        page: 1,
        limit: 5,
      },
      loading: false,
      multipleJobVisible: false,
      saveRowAlert: false,
      tableDisabled: false,
      rowErrors: {},
    };
  }

  generateTableColumns = () => {
    const { activityType } = this.props;
    const { data, dataJasa, dataSatuan, tableDisabled } = this.state;

    const baseColumns = [
      {
          name: "",
          label: "No",
          options: {
              customBodyRender: (value, tableMeta) => {
                  return <>{tableMeta.rowIndex + 1}</>;
              },
              sort: false,
          },
      },
      {
        name: "serviceCode",
        label: "Kode Jasa/Job",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const saved = data[rowIndex].saved !== false;

            if (saved || activityType === "VIEW") return <>{val}</>;

            const currentJasa = dataJasa?.find((p) => p.value === val);

            return (
              <>
                <SimpleDDL
                  id="input_text_kode_service"
                  box="search"
                  name="serviceCode"
                  readOnly={tableDisabled}
                  isClearable
                  containerclassname="margin-bottom-none width width-250px"
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      position: "relative",
                      fontFamily:
                        "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                    }),
                  }}
                  options={dataJasa.map((item) => ({
                    label: `${item.value} - ${item.label}`,
                    value: item.value,
                    serviceName: item.label,
                    serviceCategory: item.serviceCategory,
                    serviceId: item.serviceId,
                    kodeVarian: item.kodeVarian,
                    namaVarian: item.namaVarian,
                  }))}
                  value={
                    val
                      ? {
                          label: `${val} - ${currentJasa?.label || ""}`,
                          value: val,
                        }
                      : ""
                  }
                  formatOptionLabel={(option, { context }) =>
                    context === "value" ? option.value : option.label
                  }
                  onChange={(selected) =>
                    this.handleRowValueChange(rowIndex, "serviceCode", selected)
                  }
                />
                {this.state.rowErrors?.[rowIndex]?.serviceCode && (
                  <p style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    {this.state.rowErrors[rowIndex].serviceCode}
                  </p>
                )}
              </>
            );
          },
        },
      },
      {
        name: "serviceName",
        label: "Nama Jasa/Job",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            let save = data[rowIndex].saved !== false;
            if (save || activityType === "VIEW") {
              return <>{val}</>;
            } else {
              return (
                <>
                  <SimpleDDL
                    id="input_text_kode_part"
                    box="search"
                    name="serviceName"
                    readOnly={tableDisabled}
                    isClearable
                    containerclassname="margin-bottom-none width width-250px"
                    styles={{
                      menu: (provided) => ({
                        ...provided,
                        position: "relative",
                        fontFamily:
                          "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                      }),
                    }}
                    options={dataJasa}
                    value={this.findLabel(data[rowIndex].serviceCode, dataJasa)}
                    onChange={(event) => {
                      this.handleRowValueChange(rowIndex, "serviceName", event);
                    }}
                  />
                  {this.state.rowErrors?.[rowIndex]?.serviceName && (
                    <p style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                      {this.state.rowErrors[rowIndex].serviceName}
                    </p>
                  )}
                </>
              );
            }
          },
        },
      },
      {
        name: "serviceCategory",
        label: "Service Category",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            let saved = data[rowIndex].saved !== false;
            if (saved || activityType === "VIEW") {
              return <>{val}</>;
            } else {
              return (
                <>
                  <SimpleInput
                    id="input_text_part_category"
                    name="serviceCategory"
                    readOnly={true}
                    containerclassname="margin-bottom-none width width-250px"
                    value={val}
                  />
                  {this.state.rowErrors?.[rowIndex]?.serviceCode && (
                    <p
                      style={{ color: "red", fontSize: 12, marginTop: 20 }}
                    ></p>
                  )}
                </>
              );
            }
          },
        },
      },
      {
        name: "kodeVariant",
        label: "Kode Variant",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            let saved = data[rowIndex].saved !== false;
            if (saved || activityType === "VIEW") {
              return <>{val}</>;
            } else {
              return (
                <>
                  <SimpleInput
                    id="input_text_part_category"
                    name="kodeVariant"
                    readOnly={true}
                    containerclassname="margin-bottom-none width width-250px"
                    value={val}
                  />
                  {this.state.rowErrors?.[rowIndex]?.serviceCode && (
                    <p
                      style={{ color: "red", fontSize: 12, marginTop: 20 }}
                    ></p>
                  )}
                </>
              );
            }
          },
        },
      },
      {
        name: "namaVariant",
        label: "Nama Variant",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            let saved = data[rowIndex].saved !== false;
            if (saved || activityType === "VIEW") {
              return <>{val}</>;
            } else {
              return (
                <>
                  <SimpleInput
                    id="input_text_part_category"
                    name="namaVariant"
                    readOnly={true}
                    containerclassname="margin-bottom-none width width-250px"
                    value={val}
                  />
                  {this.state.rowErrors?.[rowIndex]?.serviceCode && (
                    <p
                      style={{ color: "red", fontSize: 12, marginTop: 20 }}
                    ></p>
                  )}
                </>
              );
            }
          },
        },
      },
      {
        name: "unit",
        label: "Satuan",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            let save = data[rowIndex].saved !== false;

            if (save || activityType === "VIEW") return <>{val}</>;

            const currentUnit = dataSatuan.find((s) => s.value === val);

            return (
              <>
                <SimpleDDL
                  id="input_text_unit"
                  box="search"
                  name="unit"
                  readOnly={tableDisabled}
                  isClearable
                  containerclassname="margin-bottom-none width width-250px"
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      position: "relative",
                      fontFamily:
                        "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                    }),
                  }}
                  options={dataSatuan}
                  value={
                    val ? { label: currentUnit?.label || val, value: val } : ""
                  }
                  onChange={(event) =>
                    this.handleRowValueChange(rowIndex, "unit", event)
                  }
                />
                {this.state.rowErrors?.[rowIndex]?.unit && (
                  <p style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    {this.state.rowErrors[rowIndex].unit}
                  </p>
                )}
              </>
            );
          },
        },
      },
      {
        name: "discountValue",
        label: "Nilai Diskon",
        options: {
          customBodyRender: (val, { rowIndex }) => {
            const saved = data[rowIndex].saved !== false;
            const unit = data[rowIndex]?.unit;
            const { prefix, suffix } = this.getPrefixSuffixColumn(unit);

            if (saved || activityType === "VIEW") {
              return (
                <>
                  {prefix}
                  {FormatCurrencyWithoutSymbol({ number: val })}
                  {suffix}
                </>
              );
            }

            return (
              <>
                <SimpleInput
                  id="input_text_off_price"
                  prefix={prefix}
                  suffix={suffix}
                  name="discountValue"
                  readOnly={tableDisabled}
                  containerclassname="margin-bottom-none width width-250px"
                  box="number"
                  value={
                    unit === "CURRENCY"
                      ? FormatCurrencyWithoutSymbol({ number: val })
                      : val
                  }
                  onValueChange={({ value }) => {
                    const target = { value };
                    this.handleRowValueChange(
                      rowIndex,
                      "discountValue",
                      target
                    );
                  }}
                />
                {this.state.rowErrors?.[rowIndex]?.discountValue && (
                  <p style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    {this.state.rowErrors[rowIndex].discountValue}
                  </p>
                )}
              </>
            );
          },
        },
      },
    ];

    // Column action
    if (activityType !== "VIEW") {
      baseColumns.push({
        name: "action",
        label: "Aksi",
        options: {
          customBodyRender: (_, tableMeta) => {
            const index = tableMeta.rowIndex;
            const row = data[index];
            const isEditing = this.state.editingIndex === index;

            return (
              <FlexView vAlignContent="center" style={{ gap: 10 }}>
                {(row.isNew && !row.saved) || isEditing ? (
                  <>
                    <Button
                      className="btnAct"
                      disabled={tableDisabled}
                      onClick={() => this.handleSaveRow(index)}
                    >
                      <i
                        className="fa fa-save"
                        style={{
                          fontSize: 20,
                          color: tableDisabled ? "black" : "red",
                        }}
                      />
                    </Button>
                    <Button
                      className="btnAct"
                      disabled={tableDisabled}
                      onClick={() => this.handleDeleteRow(index)}
                    >
                      <i
                        className="fa fa-times-circle"
                        style={{
                          fontSize: 20,
                          color: tableDisabled ? "black" : "red",
                        }}
                      />
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      className="btnAct"
                      disabled={tableDisabled}
                      onClick={() => this.handleEditRow(index)}
                    >
                      <i
                        className="fa fa-pencil-alt"
                        style={{
                          fontSize: 20,
                          color: tableDisabled ? "black" : "red",
                        }}
                      />
                    </Button>
                    <Button
                      className="btnAct"
                      disabled={tableDisabled}
                      onClick={() => this.handleDeleteRow(index)}
                    >
                      <i
                        className="fa fa-times-circle"
                        style={{
                          fontSize: 20,
                          color: tableDisabled ? "black" : "red",
                        }}
                      />
                    </Button>
                  </>
                )}
              </FlexView>
            );
          },
        },
      });
    }

    return baseColumns;
  };

  async componentDidMount() {
    await this.fetchJobJasa();
  }

  fetchJobJasa = async () => {
    try {
      const response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").masterServiceMainPage,
        menuName: "Master Part Price",
        setError: this.props.setError,
        args: {},
      });
      if (response.ok && response.data?.data) {
        const dataJasa = response.data.data.map((item) => ({
          label: item.namaJasa,
          value: item.kodeJasa,
          serviceCategory: item.serviceCategory,
          serviceId: item.serviceId,
          kodeVarian: item.kodeVarian,
          namaVarian: item.namaVarian,
        }));

        this.setState((prevValue) => ({
            ...prevValue,
            dataJasa,
        }));
      }
    } catch (error) {
      console.error("Gagal fetch cabang by main dealer:", error);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      const newData = (this.props.data || []).map((item) => {
        const existing = this.state.data.find((d) => d.id === item.id);
        return {
          ...item,
          saved: existing?.saved ?? true,
          isNew: existing?.isNew ?? false,
        };
      });

      this.setState({
        data: newData,
        pagination: {
          ...this.state.pagination,
          totalData: newData.length,
        },
      });
    }

    if (prevProps.errors !== this.props.errors) {
      this.setState({ rowErrors: this.props.errors });
    }
  }

  getPrefixSuffixColumn = (unit) => {
    if (!unit) return { prefix: "", suffix: "" };

    if (unit === "AMOUNT") {
      return { prefix: "Rp. ", suffix: "" };
    }

    if (unit === "PERCENTAGE") {
      return { prefix: "", suffix: "%" };
    }

    return { prefix: "", suffix: "" };
  };

  updateData = (newData) => {
    if (typeof this.props.onDataChange === "function") {
      this.props.onDataChange("job", newData);
    }

    this.setState({ data: newData });
  };

  findLabel = (value, options) => {
    if (!value) return "";
    if (Array.isArray(value)) {
      return value
        .map((value) => options.find((item) => item.value === value))
        .filter((item) => item);
    }
    const label = options.find((item) => item.value === value);
    return label ? label : "";
  };

  handleAddRow = () => {
    const updated = [
      ...this.state.data,
      {
        // id: null,
        id: uuidv4(),
        serviceCode: null,
        serviceName: null,
        serviceCategory: null,
        kodeVariant: null,
        namaVariant: null,
        unit: null,
        discountValue: null,
        isNew: true,
        parentPromoId: null,
        promoJobId: null,
        saved: false,
      },
    ];
    this.setState({
      data: updated,
      pagination: { ...this.state.pagination, totalData: updated.length },
    });
    this.updateData(updated);
  };

  handleEditRow = (index) => {
    this.setState((prevState) => {
      const updatedData = prevState.data.map((row, i) => {
        if (i === index) {
          return { ...row, saved: false };
        }
        return row;
      });

      return {
        data: updatedData,
        editingIndex: index,
      };
    });
  };

  handleSaveRow = async (index) => {
    const { data } = this.state;
    const row = data[index];
    const newRowErrors = {};

    if (!row.serviceCode) newRowErrors.serviceCode = "Field wajib diisi";
    if (!row.serviceName) newRowErrors.serviceName = "Field wajib diisi";
    if (!row.unit) newRowErrors.unit = "Field wajib diisi";
    if (
      row.discountValue === "" ||
      row.discountValue === 0 ||
      row.discountValue === "0"
    )
      newRowErrors.discountValue = "Field wajib diisi";

    if (Object.keys(newRowErrors).length > 0) {
      this.setState((prev) => ({
        rowErrors: {
          ...prev.rowErrors,
          [index]: newRowErrors,
        },
      }));
      return;
    }

    const isDuplicate = data.some(
      (item, i) =>
        i !== index &&
        item.serviceCode === row.serviceCode &&
        item.kodeVariant === row.kodeVariant
    );

    if (isDuplicate) {
      this.setState((prev) => ({
        rowErrors: {
          ...prev.rowErrors,
          [index]: {
            serviceCode: "Data Job/Jasa sudah terdapat pada list.",
          },
        },
      }));
      return;
    }

    this.setState(
      (prevState) => {
        const updatedData = [...prevState.data];
        updatedData[index] = {
          ...updatedData[index],
          saved: true,
          isNew: false,
        };

        const updatedErrors = { ...prevState.rowErrors };
        delete updatedErrors[index];

        return {
          data: updatedData,
          editingIndex: null,
          rowErrors: updatedErrors,
        };
      },
      () => this.updateData(this.state.data)
    );
  };

  handleDeleteRow = (index) => {
    this.setState(
      (prevState) => {
        const updatedData = prevState.data.filter((_, i) => i !== index);

        return {
          ...prevState,
          data: updatedData,
          pagination: {
            ...prevState.pagination,
            totalData: updatedData.length,
          },
          editingIndex:
            prevState.editingIndex === index ? null : prevState.editingIndex,
        };
      },
      () => {
        this.updateData(this.state.data);
      }
    );
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  handleTriggerLoading = (status = null) => {
    this.setState((prev) => ({
      ...prev,
      loading: status !== null ? status : !prev.loading,
    }));
  };

  getPrefixSuffix = () => {
    const unitControl = this.props.controls?.promoAllJobUnit;
    if (!unitControl) return { prefix: "", suffix: "" };

    const unit =
      typeof unitControl === "string"
        ? unitControl
        : unitControl?.value?.value || unitControl?.value || "";

    if (unit === "AMOUNT") return { prefix: "Rp. ", suffix: "" };
    if (unit === "PERCENTAGE") return { prefix: "", suffix: "%" };

    return { prefix: "", suffix: "" };
  };

  handleShowMultipleJob = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      multipleJobVisible: !prevValue.multipleJobVisible,
    }));
  };

  handleRowValueChange = (rowIndex, input, event) => {
    if (!event) {
      this.setState(
        (prevState) => {
          const updatedData = [...prevState.data];
          const updatedErrors = { ...prevState.rowErrors };

          if (updatedErrors[rowIndex] && updatedErrors[rowIndex][input]) {
            delete updatedErrors[rowIndex][input];
            if (Object.keys(updatedErrors[rowIndex]).length === 0) {
              delete updatedErrors[rowIndex];
            }
          }

          let updatedRow = { ...updatedData[rowIndex] };

          if (input === "serviceCode" || input === "serviceName") {
            updatedRow = {
              ...updatedRow,
              serviceCode: "",
              serviceName: "",
              serviceCategory: "",
              kodeVariant: "",
              namaVariant: "",
            };
          } else {
            updatedRow = { ...updatedRow, [input]: "" };
          }

          updatedData[rowIndex] = updatedRow;

          return { ...prevState, data: updatedData, rowErrors: updatedErrors };
        },
        () => this.updateData(this.state.data)
      );
      return;
    }

    this.setState(
      (prevState) => {
        const updatedData = [...prevState.data];
        const selectedJasa = prevState.dataJasa.find(
          (p) => p.value === event.value || p.label === event.label
        );

        const updatedErrors = { ...prevState.rowErrors };
        if (updatedErrors[rowIndex] && updatedErrors[rowIndex][input]) {
          delete updatedErrors[rowIndex][input];
          if (Object.keys(updatedErrors[rowIndex]).length === 0) {
            delete updatedErrors[rowIndex];
          }
        }

        let updatedRow = { ...updatedData[rowIndex] };

        switch (input) {
          case "serviceCode":
          case "serviceName":
            updatedRow = {
              ...updatedRow,
              serviceCode: selectedJasa?.value || event.value,
              serviceName: selectedJasa?.label || event.namaJasa || event.label,
              serviceCategory:
                selectedJasa?.serviceCategory || updatedRow.serviceCategory,
              kodeVariant: selectedJasa?.kodeVarian || updatedRow.kodeVarian,
              namaVariant: selectedJasa?.namaVarian || updatedRow.namaVarian,
            };
            break;

          case "unit":
            updatedRow = {
              ...updatedRow,
              unit: event.value,
              discountValue: "",
            };
            break;

          default:
            updatedRow = {
              ...updatedRow,
              [input]: event.value,
            };
            break;
        }

        updatedData[rowIndex] = updatedRow;
        return { ...prevState, data: updatedData, rowErrors: updatedErrors };
      },
      () => this.updateData(this.state.data)
    );
  };

  handleSaveAlertModalVisibility = (text) => {
    this.setState((prevState) => ({
      ...prevState,
      warningMessage: text,
      saveRowAlert: !prevState.saveRowAlert,
    }));
  };

  handleValueChange = (name, { value }) => {
    this.props.setValue(name, value);
  };

  handleSubmitMultipleJob = (jobsFromModal) => {
    console.log(jobsFromModal);

    if (!Array.isArray(jobsFromModal) || jobsFromModal.length === 0) return;

    this.setState(
      (prevState) => {
        const existingData = prevState.data;

        const newJobs = jobsFromModal.filter((job) => {
          const kodeVariant = job.kodeVariant || job.variant?.kodeVariant || "";
          return !existingData.some(
            (d) =>
              d.serviceCode === job.serviceCode && d.kodeVariant === kodeVariant
          );
        });

        const formattedNewJobs = newJobs.map((job) => {
          const kodeVariant = job.kodeVariant || job.variant?.kodeVariant || "";
          const namaVariant = job.variant?.namaVariant || "";

          return {
            id: uuidv4(),
            serviceCode: job.serviceCode,
            serviceName: job.serviceName,
            serviceCategory: job.serviceCategory,
            kodeVariant: kodeVariant,
            namaVariant: namaVariant,
            unit: null,
            discountValue: null,
            isNew: true,
            saved: false,
            parentPromoId: null,
            promoJobId: null,
          };
        });

        const updatedData = [...existingData, ...formattedNewJobs];
        console.log(updatedData);

        return {
          data: updatedData,
          multipleJobVisible: false,
          pagination: {
            ...prevState.pagination,
            totalData: updatedData.length,
          },
        };
      },
      () => this.updateData(this.state.data)
    );
  };

  handleAllJobChange = () => {
    const { controls, setValue } = this.props;
    const newValue = !controls?.promoAllJob?.value;

    setValue("promoAllJob", newValue);
    this.setState({ tableDisabled: newValue });

    if (!newValue) {
      setValue("promoAllJobUnit", null);
      setValue("promoAllJobValue", 0);

      this.setState((prevState) => ({
        ...prevState,
        rowErrors: {
          ...prevState.rowErrors,
          promoAllJobUnit: undefined,
          promoAllJobValue: undefined,
        },
      }));
    }
  };

  render() {
    const { pagination, data, tableDisabled } = this.state;
    const { prefix, suffix } = this.getPrefixSuffix();
    const { controls, activityType } = this.props;

    return (
      <>
        {activityType !== "VIEW" && (
          <FlexView style={{ margin: "20px 0px" }}>
            <SimpleButton
              secondary={
                tableDisabled || controls?.promoAllJob?.value ? true : false
              }
              style={{ marginLeft: 0 }}
              disabled={tableDisabled || controls?.promoAllJob?.value}
              icon={<i className="fa fa-plus margin-right-10px" />}
              onClick={this.handleAddRow}
            >
              Tambah
            </SimpleButton>
            <SimpleButton
              secondary={
                tableDisabled || controls?.promoAllJob?.value ? true : false
              }
              style={{ width: 172 }}
              disabled={tableDisabled || controls?.promoAllJob?.value}
              icon={<i className="fa fa-plus margin-right-10px" />}
              onClick={() => this.handleShowMultipleJob()}
            >
              Tambah Multiple Job
            </SimpleButton>
          </FlexView>
        )}

        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            gap: 16,
          }}
        >
          <SimpleCheckBox
            id="allJob"
            name="promoAllJob"
            label="All Job"
            styles={{ marginBottom: 4 }}
            checked={controls?.promoAllJob?.value || false}
            onChange={this.handleAllJobChange}
            disabled={this.props.activityType === ACTIVITY_TYPE.VIEW}
          />

          <div style={{ display: "flex", marginLeft: 45, marginBottom: 20 }}>
            <p style={{ marginTop: 27 }}>
              Satuan :
              {controls?.promoAllJob?.value && (
                <span style={{ color: "red" }}> *</span>
              )}
            </p>
            <div style={{ width: 250, marginLeft: 10, marginTop: 13 }}>
              <SimpleDDL
                id="select_options_satuan"
                name="promoAllJobUnit"
                box="search"
                value={controls?.promoAllJobUnit?.value}
                options={this.state.dataSatuan}
                isClearable
                containerclassname="margin-bottom-none width width-250px"
                readOnly={
                  this.props.activityType === ACTIVITY_TYPE.VIEW ||
                  !controls?.promoAllJob?.value
                }
                onChange={(value) => {
                  this.props.setValue("promoAllJobUnit", value);
                  this.props.setValue("promoAllJobValue", "");
                }}
              />
              {this.state.rowErrors?.promoAllJobUnit && (
                <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                  {this.state.rowErrors?.promoAllJobUnit}
                </div>
              )}
            </div>
          </div>

          <div style={{ display: "flex", marginLeft: 10 }}>
            <p style={{ marginTop: 17 }}>
              Nilai Diskon :
              {controls?.promoAllJob?.value && (
                <span style={{ color: "red" }}> *</span>
              )}
            </p>
            <div style={{ marginBottom: 10 }}>
              <SimpleInput
                id="input_text_off_diskon"
                name="promoAllJobValue"
                style={{ marginLeft: 10 }}
                containerclassname="margin-bottom-none width width-250px"
                readOnly={
                  this.props.activityType === ACTIVITY_TYPE.VIEW ||
                  !controls?.promoAllJob?.value
                }
                box="number"
                prefix={prefix}
                suffix={suffix}
                value={controls?.promoAllJobValue?.value}
                onValueChange={(val) =>
                  this.handleValueChange("promoAllJobValue", val)
                }
              />
              {this.state.rowErrors?.promoAllJobValue && (
                <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                  {this.state.rowErrors?.promoAllJobValue}
                </div>
              )}
            </div>
          </div>
        </div>

        <SimpleDataTable
          // key={`${pagination.totalData}-${pagination.page}`}
          key={`${pagination.page}-${pagination.totalData}`}
          data={data}
          columns={this.generateTableColumns()}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
          isRowDisabled={tableDisabled}
        />

        {this.state.multipleJobVisible && (
          <MultipleJobModal
            {...this.props}
            visible={this.state.multipleJobVisible}
            onClickClose={this.handleShowMultipleJob}
            triggerLoading={this.handleTriggerLoading}
            onSubmit={this.handleSubmitMultipleJob}
          />
        )}

        {this.state.saveRowAlert && (
          <SimpleAlert
            title={"Information"}
            content={
              <div>
                <p>
                  {this.state.warningMessage}
                  <br />
                  Mohon periksa kembali.
                </p>
              </div>
            }
            visible={this.state.saveRowAlert}
            onClickClose={this.handleSaveAlertModalVisibility}
            additionalButtons={
              <SimpleButton
                type="button"
                text="OK"
                onClick={() => this.handleSaveAlertModalVisibility()}
              />
            }
          />
        )}

        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

export default TabJob;
